import Viewer from 'viewerjs'
import { getWebToken } from '@/common/utils/common.js'
import { FILE_ROOT, FILE_ACCESS_PRIVATE } from '@/common/constants'

let preview_z_index = 4000

function getZIndex() {
  preview_z_index += 1
  return preview_z_index
}

/**
 * @param {*} images:Array fk or url
 */
function previewImage(images, options = {}) {
  if (!Array.isArray(images)) {
    images = [images]
  }
  images = images.map(ele => {
    if (ele.startsWith('o')) {
      return FILE_ROOT + ele
    } else if (ele.startsWith('f')) {
      return `${FILE_ACCESS_PRIVATE + ele}&_tk=${getWebToken()}`
    } else {
      return ele
    }
  })

  if (!this.previewDivContainer) {
    this.previewDivContainer = document.createElement('div')
  }
  let previewBox = this.previewDivContainer.querySelector(`#box${images.length}`)
  if (!previewBox) {
    previewBox = document.createElement('div')
    previewBox.id = `box${images.length}`
    images.forEach(url => {
      let img = document.createElement('img')
      img.src = url
      previewBox.appendChild(img)
    })
    this.previewDivContainer.appendChild(previewBox)
    previewBox.viewer = new Viewer(previewBox, {
      navbar: images.length === 1 ? false : true,
      title: false,
      zIndex: getZIndex(),
      toolbar: {
        zoomIn: true,
        zoomOut: true,

        play: {
          show: 0
        },
        prev: images.length === 1 ? false : true,
        next: images.length === 1 ? false : true,
        rotateLeft: true,
        reset: true,
        rotateRight: true,
        flipHorizontal: true,
        flipVertical: true
      },
      ...(options || {})
    })
  } else {
    for (let i = 0; i < previewBox.children.length; i++) {
      previewBox.children[i].src = images[i]
    }
  }
  previewBox.viewer.show()
  return previewBox.viewer
}

/**
 * 在vue组件beforeDestroy or  beforeDestroy 调用此方法
 */
function previewDestroy() {
  if (this.previewDivContainer) {
    this.previewDivContainer = null
  }
  const viewer = document.querySelectorAll('.viewer-container')
  if (viewer && viewer.length > 0) {
    viewer.forEach(ele => {
      document.body.removeChild(ele)
    })
  }
}

export default {
  previewImage,
  previewDestroy
}
